<!--
  新建 回款单特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 归属人 -->
    <template v-if="item.attr === 'belong'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>

    <!-- 归属人 -->
    <template v-if="item.attr === 'belongId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>

    <!-- 关联客户 -->
    <template v-if="item.attr === 'customer'">
      <associated-field
        :item="item"
        :form="form">
      </associated-field>
    </template>

    <!-- 关联合同 -->
    <template v-if="item.attr === 'contract'">
        <associated-field :item="item" :form="form">
        </associated-field>
    </template>
  </div>

</template>

<script>
import vManager from 'components/fieldtype/manager'
import associatedField from '../associated-field'

export default {
  props: ['item', 'form'],
  data () {
    return {
    }
  },
  mounted () {
    // console.log('回款红冲新建')
  },
  methods: {
    // ...mapActions([
    //   'setAttr'
    // ])
  },
  components: {
    vManager,
    associatedField
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// index.vue?6ee73fc6